import { AbstractDestroyable, destroySafe, MutableRecordStore, Store } from '@deqo/foundation';
import { uuid } from '../../../CodesThatsGottaGoSomewhereElse';
import { TopicManager } from '../../../concepts/objects/TopicManager';
import { TopicSubscription } from '../../../concepts/objects/TopicSubscription';
import { Point } from '../../../platform/geom/Point';
import { ParticipantManager } from '../../canvas/participants/ParticipantManager';
import { resolve } from '../../Container';
import { isItXmas } from '../../occasions/xmas/WithXmas';
import { ProfileModel } from '../../ProfileModel';
import { ToastHub } from '../toast/ToastHub';
import { HattingState } from './HatTypes';

class HatStore extends MutableRecordStore({} as HattingState) {

}

export class HatController extends AbstractDestroyable {

    @resolve(ParticipantManager) private participants!: ParticipantManager;
    @resolve(ProfileModel) private me!: ProfileModel;
    @resolve(ToastHub) private toast!: ToastHub;
    @resolve(TopicManager) private topics!: TopicManager;

    private store = new HatStore();
    private topic = null as TopicSubscription<HattingState>;

    protected async start() {
        this.burden(
            () => destroySafe(this.topic),
        );
        await this.subscribe();
        if (isItXmas()) {
            this.setUserHat(this.me.id, 'Santa');
        }
    }

    public getStore(): Store<HattingState> {
        return this.store;
    }

    public setUserHat(userId: string, type?: string) {
        this.topic.patch({ [userId]: ['wear', type] });
        this.sync();
        // this.toast.send(value ? 'ptpt:ready' : 'ptpt:notReady', {});
    }

    public throwUserHat(userId: string, [a, b]: [Point, Point]) {
        const hatting = this.topic.getState();
        const current = hatting[userId] ?? [];
        if ((current[0] === 'wear' || current[1] === 'throw') && !!current[1]) {
            const type = current[1];
            this.topic.patch({ [userId]: ['throw', type, [a.x, a.y, b.x, b.y], uuid()] });
            this.sync();
        }
    }

    private subscribe = async () => {
        this.topic = await this.topics.subscribe<HattingState>('hatting');
        this.topic.observe(() => this.sync());
        this.sync();
    };

    private sync = () => {
        const state = this.topic.getState();
        for (const ptpt of this.participants) {
            const [key, type] = state[ptpt.id] ?? [];
            if (key === 'wear' && ptpt.hat !== type) {
                ptpt.update({ hat: type });
            }
            else if (key !== 'wear' && !!ptpt.hat) {
                ptpt.update({ hat: '' });
            }
        }
        this.store.mutateTo(state);
    };
}
